import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function DesktopApps() {
  return <ServiceDetailPage service={servicePageContent.desktopApps} />;
}
